// extracted by mini-css-extract-plugin
export default {"tag_container":"styles_tag_container__LMjDd"};